import { useState } from "react";
import { ChevronDown, ChevronUp, Trash2 } from "lucide-react";
import { Dropdown } from "../Dropdown";

export function UserMealFormIngredientCollapsibleRow({
  ingredient,
  updateIngredient,
  removeIngredient,
  showDeleteButton,
  ingredientUnits,
}) {
  const [isExpanded, setIsExpanded] = useState(!ingredient.name);

  const hasName = !!ingredient.name?.trim();

  const quantitySummary =
    ingredient.quantity && ingredient.unit
      ? `${ingredient.quantity} ${ingredient.unit}`
      : ingredient.quantity || ingredient.unit || "";

  return (
    <div className="border border-gray-200 rounded-xl">
      {/* Collapsed header row — always visible */}
      <button
        type="button"
        onClick={() => setIsExpanded((prev) => !prev)}
        className={`w-full flex items-center gap-3 px-4 py-3 bg-white hover:bg-gray-50 active:bg-gray-100 transition-colors text-left ${isExpanded ? "rounded-t-xl" : "rounded-xl"}`}
      >
        <span className="flex-1 text-sm font-medium truncate min-w-0">
          {hasName ? (
            <span className="text-gray-900">{ingredient.name}</span>
          ) : (
            <span className="text-gray-400 italic">New ingredient</span>
          )}
        </span>
        {quantitySummary && !isExpanded && (
          <span className="text-xs text-gray-500 shrink-0 mr-1">
            {quantitySummary}
          </span>
        )}
        {isExpanded ? (
          <ChevronUp className="w-4 h-4 text-gray-400 shrink-0" />
        ) : (
          <ChevronDown className="w-4 h-4 text-gray-400 shrink-0" />
        )}
      </button>

      {/* Expanded edit area */}
      {isExpanded && (
        <div className="px-4 pb-4 pt-2 bg-gray-50 border-t border-gray-100 space-y-3 rounded-b-xl overflow-visible">
          {/* Name */}
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">
              Name
            </label>
            <input
              type="text"
              value={ingredient.name}
              onChange={(e) => updateIngredient(ingredient.id, "name", e.target.value)}
              placeholder="e.g. Chicken breast"
              required
              className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
            />
          </div>

          {/* Quantity + Unit */}
          <div className="flex gap-3">
            <div className="w-24 shrink-0">
              <label className="block text-xs font-medium text-gray-500 mb-1">
                Quantity
              </label>
              <input
                type="text"
                inputMode="decimal"
                value={ingredient.quantity}
                onChange={(e) => updateIngredient(ingredient.id, "quantity", e.target.value)}
                placeholder="e.g. 200"
                required
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
              />
            </div>
            <div className="flex-1">
              <label className="block text-xs font-medium text-gray-500 mb-1">
                Unit
              </label>
              <Dropdown
                options={ingredientUnits}
                selectedOption={ingredient.unit}
                onSelect={(unit) => updateIngredient(ingredient.id, "unit", unit)}
              />
            </div>
          </div>

          {/* Delete */}
          {showDeleteButton && (
            <button
              type="button"
              onClick={() => removeIngredient(ingredient.id)}
              className="flex items-center gap-1.5 text-xs font-medium text-gray-400 hover:text-red-500 transition-colors pt-1"
            >
              <Trash2 className="w-3.5 h-3.5" />
              Remove ingredient
            </button>
          )}
        </div>
      )}
    </div>
  );
}
